import { ChatSessionService } from "../../../services/chat-session.service";

export const withGlobalFunctions = () => {
  Object.assign(window, {
    getChatbotUserSession: ChatSessionService.retrieveEntireSession,
  });
}
